export default {
  angentManage: {
    chargePlan: '收费方案',
    organizationTag: '组织标签',
    textje8x: '文件名',
    textd6a5: '大小',
    fileStatus: '文件状态',
    operator: '操作人',
    operationTime: '操作时间',
    remark: '备注',
    confirmDeleteExportFile: '确定要删除文件「{fileName}」吗？',
    auto_108_00bbd0a1: '新增学校',
    auto_109_323176e9: '批量关联校区',
    auto_110_0aba07e4: '编辑',
    auto_111_3974910f: '关联校区',
    auto_112_267ce3c2: '移除',
    auto_113_d0221b28: '提示',
    auto_114_3968fa67: '是否确认移除',
    auto_115_84ac5284: '学校名称',
    auto_116_60fb16eb: '请输入学校名称',
    auto_117_0a6559c0: '学校省市区',
    auto_118_184bc002: '学校学段',
    auto_119_a311294f: '请选择学校学段',
    auto_120_f64f7d06: '办学性质',
    auto_121_cc0135ad: '请选择办学性质',
    auto_122_917d1b7f: '寄宿情况',
    auto_125_9a2afdd5: '请选择校区',
    auto_126_bc008c75: '操作',
    auto_130_e9c403b6: '学校地址',
    auto_131_d0c268a5: '请填写学校地址',
    auto_133_880878f8: '请选择寄宿情况',
    auto_137_c5f37b51: '请选办学性质',
    auto_138_7b608045: '学校人数',
    auto_139_7ac46c85: '请输入学校人数',
    auto_140_bb775e75: '班级数',
    auto_141_ac4379b9: '请输入班级数',
    auto_142_5dba9534: '学校概况',
    auto_143_c75e0f9e: '请输入学校概况最大1000字',
    auto_144_5501bd34: '备注',
    auto_145_4ab32238: '请输入备注最大500字',
    auto_147_48b76f6a: '选择校区',
    auto_414_b30f89a0: '清除筛选',
    auto_419_d52d4a56: '详细地址',
    auto_430_72b510b7: '编辑学校',
    auto_1_5dbea729: '新增',
    auto_6_2ad7d5e1: '全部校区',
    auto_7_6b74106c: '部分校区',
    auto_10_acbcbf89: '广告位置',
    auto_11_4b1e5ce3: '请选择广告位置',
    auto_12_98bf012e: '广告名称',
    auto_12_d7bddb28: '新增广告',
    auto_13_8a858b9d: '省市',
    auto_13_a12733c2: '请输入广告名称',
    auto_14_0232da13: '收费状态',
    auto_14_6f6fd7f3: '排序',
    auto_15_0e39805e: '请设置排序',
    auto_15_9197175c: '校区类型',
    auto_16_dcebb3c9: '校区性质',
    auto_17_02f830c2: '自定义',
    auto_17_796dbe36: '广告图片',
    auto_18_58acb097: '状态',
    auto_19_8eda55dc: '显示范围',
    auto_20_17eb1ec8: '请选择',
    auto_22_0bd22920: '请输入',
    auto_22_33a639ad: '最后编辑时间',
    auto_23_d183ba8a: '请输入跳转Url',
    auto_24_3c3ec2fc: '路由',
    auto_24_6b417098: '免费',
    auto_25_5cad1762: '收费',
    auto_25_d6b4aa30: '请输入跳转路由',
    auto_26_92c26f06: '请选择收费状态',
    auto_26_bd20cad5: '预览',
    auto_27_a09266aa: '请选择校区类型',
    auto_28_c22fd1e2: '请选择校区性质',
    auto_30_a46e8acd: '编辑广告',
    auto_31_37a929ba: '请先选择所在地',
    auto_152_559ac074: '合同类型',
    auto_153_fd464748: '合同名称',
    auto_154_67dd4068: '合同编号',
    auto_155_9160b8a0: '合同金额',
    auto_156_42436328: '合同签署时间',
    auto_157_0cc00bfe: '合同开始时间',
    auto_158_298b8db7: '合同结束时间',
    auto_158_abbed0fc: '新增合同',
    auto_159_3fbde64c: '当月确认收入金额元',
    auto_160_33a7227b: '合同签约经理',
    auto_160_bc9ed7a4: '上传附件',
    auto_161_3b87923a: '新增协议',
    auto_162_4859590f: '创建时间',
    auto_163_6f4e4ad4: '创建人',
    auto_164_5848197c: '最新修改时间',
    auto_165_65f8c2d4: '修改人',
    auto_166_6234ffac: '文件类型',
    auto_167_5bdbf60b: '文件用途',
    auto_168_eb0b3a22: '文件签署时间',
    auto_169_6534851f: '文件签署经理',
    auto_179_fed75aa1: '编辑合同成功',
    auto_180_f808e435: '新增合同成功',
    auto_181_8f0bfc96: '编辑合同失败',
    auto_182_df277363: '新增合同失败',
    auto_183_09754d66: '编辑协议成功',
    auto_184_62c1fcf6: '新增协议成功',
    auto_185_8997f4d1: '编辑协议失败',
    auto_186_aae610db: '新增协议失败',
    auto_193_0fd9f522: '删除合同成功',
    auto_194_a280b383: '删除合同失败',
    auto_195_ed654bde: '删除协议成功',
    auto_196_a5439fb9: '删除协议失败',
    auto_199_b9cd767c: '课程取消分配后校区将不能把课程分配给学员',
    auto_368_48455d5e: '请输入课程名称',
    auto_370_5f25d5c2: '请选择科目',
    auto_376_16365df4: '请选择教材版本',
    auto_378_fd39ec5e: '请选择教材类型',
    auto_381_260a1818: '分配时间',
    auto_388_f12f16c2: '分配人',
    auto_49_d25b5fc6: '定价及系统信息',
    auto_53_f1d254ce: '开启小班课',
    auto_54_0d07eafa: '元课时',
    auto_60_fa9e90c1: '开启大班课',
    auto_64_68f3e04f: '根据校区各阶段定价同时结合定价系数校区收费后小学阶段实际支付',
    auto_65_c32bba3f: '5元课时',
    auto_67_91be6ec6: '6元课时',
    auto_69_9e03b0e6: '7元课时',
    auto_70_2d60ea96: '校区免收期各阶段实际支付为',
    auto_71_c2b1eff9: '0元课时',
    auto_77_33db3040: '验证提示',
    auto_78_4c22b5f8: '修改定价及系统信息需要发送验证码验证是否发送',
    auto_197_2627d43c: '请输入验证码',
    auto_198_3b1d3eb7: '验证码发送成功',
    auto_199_3b783b70: '验证码发送失败',
    auto_201_4c816e56: '请输入自动充值扣款比',
    auto_202_1c3a2e51: '请修改后再保存',
    auto_203_ad9868b4: '定价及系统信息保存成',
    auto_204_6e97e4df: '定价及系统信息保存失',
    auto_600166_6a425931: '初中阶段实际支付',
    auto_700168_6e3832b8: '高中阶段实付支付',
    auto_165_94efbea8: '新增初始金额',
    auto_167_57991ebf: '金账户',
    auto_205_adf76b23: '充值账户',
    auto_206_f38cead2: '初始金额',
    auto_207_f548cc9c: '付款时间',
    auto_208_f4e6d4be: '付款方式',
    auto_209_237fa570: '支付流水',
    auto_213_4b8d40e9: '最后修改人',
    auto_214_19608d29: '最后修改时间',
    auto_216_01d50fd3: '零拾',
    auto_218_1b66f4e7: '零佰',
    auto_220_a79d6f7c: '零仟',
    auto_222_0cbd246b: '零万',
    auto_224_58f35c2d: '零零零',
    auto_226_4098fa8c: '零零',
    auto_228_a30639f0: '零元',
    auto_232_24b2d4a9: '编辑代理商初始账户金',
    auto_233_7434df88: '保存成功',
    auto_234_c284074b: '是否继续',
    auto_236_0af6f5bb: '保存失败',
    auto_238_72f71c15: '删除代理商初始账户金',
    auto_27_ef3ce910: '账号信息',
    auto_28_b5eb70e1: '新增账号',
    auto_29_79eb76fb: '重置密码',
    auto_30_1962cee5: '复制邀请',
    auto_31_fa023517: '禁用账号',
    auto_32_f00f9205: '重新启用',
    auto_33_b47d9a4f: '设置为普通账号',
    auto_34_62374bc9: '发送短信',
    auto_35_0f2e8708: '网址agentsongshuaicom首次登陆后请修改密码松',
    auto_36_76937eb2: '对方确认邀请后账号自动激活',
    auto_37_7488bdd5: '标记为普通账号后将无法从代理商档案管理该账号',
    auto_38_4eb38d0f: '该ID下的主账号仍可以通过代理商经销商系统管理该账号',
    auto_49_d4dacb31: '发送邀约短信',
    auto_50_59c5a166: '重新邀约',
    auto_51_b2642af0: '邀请成功',
    auto_52_1f6a60ae: '邀请失败',
    auto_53_67fdf4be: '复制成功',
    auto_54_3fe737f2: '禁用成功',
    auto_55_d5ce9126: '禁用失败',
    auto_56_5fde9fe9: '启用成功',
    auto_57_37d1f6d9: '启用失败',
    auto_59_bff29c3c: '设置成功',
    auto_60_400460b0: '设置失败',
    auto_61_7684c8f7: '编辑账号成功',
    auto_62_7140b72f: '编辑账号失败',
    auto_64_27ef51b4: '新增账号成功',
    auto_65_bd54cc4e: '新增账号失败',
    auto_66_9c97237c: '短信发送成功',
    auto_93_6a436830: '校区档案',
    auto_96_ed64406c: '定价及系统',
    auto_99_aed51598: '大班课',
    auto_100_04cd98c2: '小班课',
    auto_101_a22a83ec: '基础信息',
    auto_102_d0f0f776: 'ip地址',
    auto_103_b6d110da: '设备信息',
    auto_104_ad632e46: '收起',
    auto_105_ef54ff00: '展开',
    auto_400_4139981b: '编辑校区',
    auto_401_85ef36f0: '待确认',
    auto_402_40941d70: '联动',
    auto_403_a698454c: '不联动',
    auto_408_14fc3601: '正式交接合作校',
    auto_409_afd388ce: '自适应重庆沙坪坝分校',
    auto_81_fd6ec8e0: '组织ID：',
    auto_82_33a82215: 'nbsp展开',
    auto_83_d4dbf580: '3nonenbsp收起',
    auto_84_384732d9: '房租年',
    auto_85_8e060283: '房租月',
    auto_86_c15acb83: 'iP地址',
    auto_87_3d415ccd: '账户名单位名称',
    auto_88_51d772a9: 'iD打卡机',
    auto_89_5904a7f9: '总部leads投放计划',
    auto_90_741a9603: '领取上限每日',
    auto_91_7f527a0c: '手机号查看上限每日',
    auto_249_3c59bc76: '正式交接',
    auto_250_f8314491: '预交接',
    auto_258_0d75af8b: '开通',
    auto_259_2cd21d0c: '关闭',
    auto_260_6e13beb2: '参与',
    auto_261_27fd171d: '不参与',
    auto_262_2206ea1f: '资料',
    auto_126_a81a7420: '上传营业执照附件',
    auto_127_f7c3dcc9: '请选择所在地',
    auto_128_c311c9f7: '请选择签约经理',
    auto_129_11b39a48: '请选择电销人员',
    auto_130_b94d4abc: '校区',
    auto_131_e260471b: '签约主体类型',
    auto_132_bcf7c0dc: '签约名称',
    auto_133_f97f507d: '变更前的签约主体类型',
    auto_134_3753c507: '签约主体名称',
    auto_135_744428fc: '变更原因',
    auto_136_8da52131: '公司',
    auto_137_2afbac64: '请输入签约主体名称',
    auto_138_57f014e9: '请输入签约人姓名',
    auto_139_d182fb77: '客户',
    auto_140_de3ad287: '客户名称',
    auto_141_23569328: '介绍人',
    auto_142_afe681e4: '介绍人名称',
    auto_143_0eff35dd: '服务器出错',
    auto_145_6f9d79e2: '签约主体保存成功',
    auto_146_9d4ad26a: '签约主体保存失败',
    auto_148_fc1ee04e: '签约基础信息保存成功',
    auto_149_3ff4a0bc: '签约基础信息保存失败',
    auto_151_b2cb1fca: '营业执照附件',
    auto_297_3d78ec77: '正式课',
    auto_298_f333a8c9: '试听课',
    auto_299_a8f3aa43: '课程名称',
    auto_300_4312ad23: '科目',
    auto_301_7da2fccf: '阶段年级',
    auto_302_1b1e015d: '教材版本',
    auto_303_d7f7b6fe: '类型',
    auto_304_7e38397a: '更新时间',
    auto_305_47aaac0f: '一年级',
    auto_306_0241ea6e: '二年级',
    auto_307_74198474: '三年级',
    auto_308_224610c8: '四年级',
    auto_309_7b55e318: '五年级',
    auto_310_9509e3db: '六年级',
    auto_312_37ee9746: '七年级',
    auto_313_cb06ad6c: '八年级',
    auto_314_e458a0da: '九年级',
    auto_315_fc9c5788: '高一',
    auto_316_7b2210ea: '高二',
    auto_317_2e0f0e6d: '高三',
    auto_318_beb4ebc6: '高四',
    auto_97_d7b966c9: '发票类型',
    auto_98_30edec66: '发票金额',
    auto_99_468c6b0e: '发票抬头',
    auto_100_aa26659d: '发票税号',
    auto_101_4decc61e: '开票时间',
    auto_102_eaefd8a1: '最大可上传的文件',
    auto_103_8f8acc83: '编辑发票成功',
    auto_104_135f847f: '新增成功',
    auto_105_455dce85: '编辑发票失败',
    auto_107_ebfbf351: '附件',
    auto_110_c7ff7093: '删除发票成功',
    auto_111_e4fb0137: '删除发票失败',
    auto_177_bc3e76a9: '0none是否已开发票',
    auto_178_12a68c31: '新增发票',
    auto_179_1458572d: '上传发票',
    auto_69_3fd38855: '生成校区成功',
    auto_70_9312017b: '合同信息提交后可生成',
    auto_71_e4fae474: '生成小松鼠校区成功',
    auto_72_94662f3c: '生成失败',
    auto_74_54000a2d: '校区基础信息保存成功',
    auto_75_8bc7f4bc: '校区基础信息保存失败',
    auto_149_f112d9ae: '校区基础信息',
    auto_150_ef222d81: '未装修',
    auto_151_6353753e: '装修中',
    auto_152_5a2c1f9e: '装修完成',
    auto_153_1b7ef83a: '新增发票信息',
    auto_154_266681a5: '新增IP地址',
    auto_155_02a34ead: '新增返还账户',
    auto_156_07401cd4: '确认生成校区ID',
    auto_157_395c1a99: '输出',
    auto_39_d4d845e5: '校区主体',
    auto_40_b5326075: '生成校区ID',
    auto_41_f9d88f13: '生成小松鼠签约校ID',
    auto_42_27271d63: '暂无定位请立即定位',
    auto_47_f4993908: '确认生成小松鼠签约校ID',
    auto_95_39c76cf4: '校区主体保存成功',
    auto_96_200716b1: '校区主体保存失败',
    auto_337_b94fcb4a: '修改',
    auto_338_86e27584: '打款人证明',
    auto_340_73b27d0e: '附件详情',
    auto_344_33cbbb5c: '删除',
    auto_348_71e39444: '板块',
    auto_349_8314398e: '变更时间',
    auto_350_0d085309: '变更人',
    auto_351_7b267482: '变更类型',
    auto_352_76d35af0: '变更字段',
    auto_84_9632590e: '新增资料成功',
    auto_85_f0e3dd3d: '新增资料失败',
    auto_86_9d561389: '删除资料成功',
    auto_87_2d4639f5: '删除资料失败',
    auto_173_3b6b8858: '新增资料',
    auto_112_b29a50cc: '订单编号',
    auto_113_2ed33fd7: '请输入订单编号',
    auto_115_f405c3c1: '客户姓名',
    auto_116_663fc5a0: '手机号',
    auto_117_9a88cff8: '订单状态',
    auto_118_5f2156c7: '订单金额',
    auto_119_22bfe9e8: '质保金',
    auto_120_614faf92: '已收金额',
    auto_121_a8918dde: '来源',
    auto_122_8424df51: '请先保存签约主体',
    auto_123_04c07abd: '请选择关联订单',
    auto_124_73595a10: '新增订单成功',
    auto_125_cdc3a9b5: '新增订单失败',
    auto_196_28920fad: '新增关联订单',
    auto_280_8bf40c6f: '全部',
    auto_282_7b521f16: '正常',
    auto_284_9c819402: '一星级',
    auto_285_9410be07: '二星级',
    auto_286_4cc3908f: '三星级',
    auto_287_2550957c: '四星级',
    auto_288_e37692b0: '五星级',
    auto_38_180ac681: '接通',
    auto_40_5b58412b: '坐席姓名',
    auto_42_8f957442: '呼叫类型',
    auto_43_f2bd5c17: '主叫号码',
    auto_44_d4347792: '被叫号码',
    auto_45_db33ce18: '通话开始时间',
    auto_46_c75c29df: '录音时长',
    auto_47_587d26e7: '通话类型',
    auto_48_8c6c4a35: '所属校区',
    auto_186_f29dba85: '播放录音',
    auto_187_bcbca59e: '通话详情',
    callRecordView: '查看',
    callRecordCallerNo: '主叫号码',
    callRecordSeatName: '坐席姓名',
    callRecordDuration: '录音时长',
    callRecordEndTime: '通话结束时间',
    callRecordRecording: '录音',
    auto_264_67741fc6: '退款账号',
    auto_265_4ae61fb3: '出款时间',
    auto_271_dbf93436: '删除成功',
    auto_272_bd6d52ad: '删除失败',
    auto_273_f75f0221: '编辑退费',
    auto_319_b5c748a3: '请选择省市区',
    auto_321_cd47f867: '省市区',
    auto_322_15891a67: '校区地址',
    auto_323_a7e1165c: '地图定位',
    auto_326_b83f30fc: '学段',
    auto_327_e42f2bff: '年级',
    auto_188_cac3a089: '代理商信息',
    auto_431_23df5e03: '规则',
    auto_432_703e94d8: '非规则',
    auto_433_a108eb61: '自主下单',
    auto_434_7ddc00bb: '新课程版',
    auto_435_74cfb7b5: '全国少儿版',
    auto_240_893162b1: '个人',
    auto_241_a237174e: '未变更',
    auto_242_85503de6: '已变更',
    auto_243_37bf8510: '下载',
    auto_245_de16923c: '合同金额元',
    auto_247_22e2b63a: '退费金额元',
    auto_248_590b290c: '释放后的校区',
    auto_169_2c7d8afe: '联系人信息',
    auto_170_c8cc4c47: '新增联系人',
    auto_172_491a2d5f: '确认删除吗',
    auto_444_1931dd78: '联系人保存成功',
    auto_445_871c454b: '联系人保存失败',
    auto_194_9e9d1b6f: '上传资料',
    auto_331_64754897: '资料类型',
    auto_332_cca45631: '资料名称',
    auto_334_c7ffc3f0: '上传时间',
    auto_335_3661a727: '上传人',
    auto_1_524f619a: '上架',
    auto_2_0df5a83d: '下架',
    auto_3_731368ac: '登录页浮窗',
    auto_4_262a7a65: '霸屏弹窗',
    auto_190_813ee734: '校区设备信息',
    auto_461_b5d06640: '校区设备信息保存成功',
    auto_462_f02bd24c: '校区设备信息保存失败',
    auto_192_56f8e083: '教材版本信息',
    auto_456_62d92b1b: '校区教材版本信息保存',
    auto_440_07489eb9: '小程序首页',
    auto_441_2ca7ae28: '小程序松鼠杯',
    auto_451_3cde6d96: '文件',
    auto_452_bca81947: '下载失败',
    auto_446_3a5e69f5: '公办',
    auto_447_4f0ebfbd: '民办',
    auto_448_7d07537e: '国际',
    auto_458_ce7a7f2d: '空闲',
    auto_459_43bd0c5e: '忙碌',
    auto_449_8e4ae13d: '已激活',
    auto_450_e46607fd: '未激活',
    auto_197_950038b1: '返回nbspnbsp',
    auto_198_945e0f9a: '清除',
    orgSupport: '支持',
    orgCampusDetailAddress: '校区详细地址',
    orgSupportHandoverTime: '支持交接时间',
    orgPlannedOpeningTime: '计划开业时间',
    orgActualOpeningTime: '实际开业时间',
    orgCampusAccountStatus: '校区账号状态',
    orgReason: '原因',
    orgChargePlan: '收费方案',
    orgFreePeriod: '免抽时间',
    orgPricingCoefficient: '定价系数',
    orgOnlineOfflineLinkageStatus: '线上线下联动状态',
    orgHeadOfficeOnlinePayment: '总部在线支付',
    orgAutoRechargeDeductionRatio: '自动充值扣款比例',
    orgMerchant: '商家',
    orgMerchantNo: '商户号',
    orgDailyClaimLimit: '领取上限（每日）',
    orgDailyPhoneViewLimit: '手机号查看上限（每日）',
    orgPrimaryPricing: '小学定价',
    orgJuniorPricing: '初中定价',
    orgHighPricing: '高中定价',
    orgPrimaryOriginalPricing: '小学原始定价',
    orgJuniorOriginalPricing: '初中原始定价',
    orgHighOriginalPricing: '高中原始定价',
    orgPerClassHour: '课时',
    orgFrontDeskPhone: '前台电话',
    orgCampusArea: '校区面积',
    orgSquareMeter: '平方米',
    orgClassroomCount: '教室数',
    orgMaxCapacity: '最多可容纳',
    orgUnitPiece: '个',
    orgUnitPeople: '人',
    orgAnnualRent: '房租/年',
    orgMonthlyRent: '房租/月',
    orgDecorationStatus: '装修状态',
    orgDecorationTime: '装修时间',
    orgConsignee: '收货人',
    orgConsigneeContact: '收货人联系方式',
    orgShippingAddress: '收货地址',
    orgTaxpayerId: '纳税人识别号',
    orgAddress: '地址',
    orgPhone: '电话',
    orgBank: '开户行',
    orgBankAccount: '开户行帐号',
    orgComputer: '电脑',
    orgPhoneDevice: '话机',
    orgIdCardPunch: 'ID打卡机',
    orgWritingTablet: '手写板',
    orgCamera: '摄像头',
    text09i2: "招生电话：",
    text0cti: "最多可容纳：",
    text1r1i: "打款状态：",
    text1trb: "股权金额：",
    text2vrw: "筹备期：",
    text3i71: "选址人员：",
    text3lej: "转换期权：",
    text3qfo: "发票抬头：",
    text400w: "第几期出款：",
    text4qds: "地址：",
    text4r3a: "联系邮箱：",
    text57ze: "商家：",
    text5ckl: "联系方式：",
    text5nzv: "第几期退款：",
    text73j3: "原因：",
    text7ghw: "定价系数：",
    text7o9x: "开户银行：",
    text8egi: "签约片区名称：",
    text9onf: "联系人姓名：",
    text9tck: "支持人员：",
    textb1gv: "手写板：",
    textb2a3: "实际退款金额：",
    textdy3e: "实收金额：",
    texte7q0: "组织标签：",
    texteb59: "开户行：",
    textf5ni: "签约保证金：",
    textf5wl: "收费状态：",
    textfhfp: "组织类型：",
    textfpkt: "附件：",
    textgw9t: "自动充值扣款比例：",
    texthuk5: "合同状态：",
    texti3gp: "组织面积：",
    textiawl: "退费总金额：",
    textj8iv: "签约金额：",
    textkcim: "释放状态：",
    textkl00: "所在地：",
    textkw0m: "组织评星：",
    textkxu2: "组织性质：",
    textln8s: "教室数：",
    textm843: "电话：",
    textmbem: "签约主体变更状态：",
    textmiqa: "是否多校：",
    textnevv: "签约经理：",
    textnfdt: "摄像头：",
    textng46: "账户类型：",
    textoe85: "组织名称：",
    textp4vn: "是否折扣合同：",
    textptcu: "开业状态：",
    textpwah: "招生邮箱：",
    textql7m: "收货人：",
    textqsri: "免抽期：",
    textrpyp: "总部在线支付：",
    textshon: "真实姓名：",
    textsnnc: "组织详细地址：",
    textt9pg: "收费方案：",
    texttesz: "签约主体：",
    texttl4e: "地级标准：",
    texttnu6: "联系电话：",
    texttvx2: "校区标签：",
    textu21u: "法人姓名：",
    textu2w0: "出款状态：",
    textu8yx: "电脑：",
    textug2a: "收货地址：",
    textuwlj: "地级标准说明：",
    textvmez: "营业执照附件：",
    textvz77: "市场补贴费：",
    textwr4i: "扣款金额：",
    textxgbj: "交接状态：",
    textxquz: "话机：",
    textyu3h: "收货人联系方式：",
    textzp3y: "装修状态：",
    text1ewz: '操作',
    text20hu: '点击查看',
    text3hl2: '导出合同',
    text3pv0: '合同附件',
    text79cm: '多校查询',
    text8f1k: '变更详情',
    textb0ke: '订单信息',
    textbccd: '片区释放',
    textbg1j: '组织信息',
    textbs5c: '退费原因：',
    textgdcv: '发票信息',
    textgk5w: '其他文件签署信息',
    textgq47: '退费方式：',
    texthi1b: '签约人联系地址：',
    textitua: '开启大班课',
    textkwte: '退费信息',
    textngln: '联系人信息',
    textq675: '组织设备信息',
    textr4ty: '开启小班课',
    texts3x4: '教材版本信息',
    textthsl: '组织主体',
    textuag3: '出款信息',
    textvj4l: '释放后的校区信息',
    textwfvm: '资料信息',
    textwkrh: '组织基础信息',
    textye7k: '定价及系统信息',
    textzgvh: '坐标拾取',
    smallsmall: '小班课小学原始定价：',
    smallmiddle: '小班课初中原始定价：',
    smallhighmiddle: '小班课高中原始定价：',
    bigsmall: '大班课小学定价：',
    bigmiddle: '大班课初中定价：',
    bighighmiddle: '大班课高中定价：',
    yihour: '第一笔出款时间：',
    er: '第二笔出款金额：',
    yi: '第一笔出款金额：',
    erhour: '第二笔出款时间：',
    backhour: '最后打款时间：',
    backyihour: '最后一笔出款时间：',
    backyi: '最后一笔出款金额：',
    textContractPeriod: '合同期限：',
    textSignTime: '签约时间：',
    textGiveDeduct: '赠送抵扣金：',
    textAccountDeductAmt: '账户抵扣金额：',
    textBizLicenseNo: '营业执照号：',
    textIdCardNo: '证件号码：',
    textTermAgreementTime: '终止协议时间：',
    textTermAgreementEntryTime: '终止协议入账时间：',
  }
};
